import { ComponentIds } from '@inter-ikea-core/core';
import { PlannerValidation, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
/**
 * LADMAKARE compartments are placed on top of shelves and cabinets (like an extra shelf)
 * This validates that the compartment is not placed on a shelf or cabinet on the top hole series
 * Since the compartment requries the panel sides for stability & it would look weird
 */
export class CompartmentPlacementValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'CompartmentPlacementValidation');
    }
    validateCurrentState(entity) {
        return this.validate(entity, undefined);
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        return this.validate(entity, snapActionCandidate);
    }
    validate(entity, snapActionCandidate) {
        const productType = entity?.getComponent(ProductInfoComponent.id)
            ?.productType;
        const entityIsCompartment = productType === ProductType.LADMAKARE_COMPARTMENT;
        const entityHasCompartment = this.coreApi.entities.getChildrenWithProductType(entity, ProductType.LADMAKARE_COMPARTMENT)
            ?.length > 0;
        // Check if entity is either a compartment, or hosting a compartment
        if (!entityIsCompartment && !entityHasCompartment) {
            return this.validationOK();
        }
        // We look at the world Y position of the host (shelf or cabinet)
        // If the host is a shelf, the max Y position is 2018 (i.e. top hole series)
        // If the host is a cabinet, the max Y position is 1778 (i.e. 4th hole series, since it takes up two hole series)
        const host = entityHasCompartment ? entity : snapActionCandidate?.host;
        const hostPositionY = host?.getComponent(ComponentIds.WORLD_TRANSFORM_COMPONENT_ID)?.transform?.position?.Y;
        const hostType = host?.getComponent(ProductInfoComponent.id)?.productType;
        if (!hostPositionY) {
            return this.validationFail('Shelf position Y is not defined');
        }
        if ((hostType === ProductType.LADMAKARE_SHELF && hostPositionY >= 2018) ||
            (hostType === ProductType.LADMAKARE_CABINET && hostPositionY >= 1778)) {
            return this.validationFail('Compartment is not allowed on top shelf');
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=CompartmentPlacementValidation.js.map